var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { reaction } from 'mobx';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { Button, Notice, Separator, Spinner, Table } from 'telia-front-react';
import customerIdAsKey from '../../auth/customerIdAsKey';
import { getPrimeOrFirstContactInfoValue } from '../../config/contact-info';
import { MandateQueryType, MandateType } from '../../config/mandate';
import { getValueOrDash } from '../../util/ParamsUtil';
import { injectStores } from '../../util/StoresUtil';
import RepresentationRightsMandateType from './RepresentationRightsMandateType';
import RepresentationRightsValidUntil from './RepresentationRightsValidUntil';
let RepresentationRightsPersonMandates = class RepresentationRightsPersonMandates extends Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "mandateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "mandatesDisposer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    componentDidMount() {
        this.mandatesDisposer = reaction(() => this.ssoStore.customerId, (customerId) => {
            if (!!customerId) {
                this.mandateStore.fetchMandates(MandateQueryType.PERSON_MANDATES);
                this.mandateStore.loadMandateInfo([MandateType.LEGAL], false);
            }
        }, { fireImmediately: true });
    }
    componentWillUnmount() {
        this.mandatesDisposer && this.mandatesDisposer();
    }
    render() {
        const { translate } = this.translateStore;
        const { customer } = this.ssoStore;
        const { isFetching, getResultValue, hasError } = this.mandateStore;
        const personMandates = getResultValue(MandateQueryType.PERSON_MANDATES).filter((personMandate) => personMandate.isVisible(customer));
        if (isFetching(MandateQueryType.PERSON_MANDATES) || isFetching(MandateQueryType.REMOVE_PERSON_MANDATE)) {
            return React.createElement(Spinner, null);
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("h3", { className: "text-weight-normal" }, translate('personPowers.personMandates.title')),
            React.createElement(Separator, { color: "invisible", spacing: "small" }),
            hasError(MandateQueryType.REMOVE_PERSON_MANDATE) && this.renderErrorNotice(),
            React.createElement(Table, { responsive: "cols", break: "sm" },
                this.renderPersonMandatesHeader(),
                personMandates.length > 0 ? this.renderPersonMandates(personMandates) : this.renderNoPersonMandatesNotice())));
    }
    renderPersonMandatesHeader() {
        const { translate } = this.translateStore;
        return (React.createElement("thead", null,
            React.createElement("tr", null,
                React.createElement("th", null, translate('personPowers.name')),
                React.createElement("th", null, translate('personPowers.registrationNumber')),
                React.createElement("th", null, translate('personPowers.phone')),
                React.createElement("th", null, translate('personPowers.email')),
                React.createElement("th", null, translate('personPowers.mandateType')),
                React.createElement("th", null, translate('personPowers.validUntil')),
                React.createElement("th", null))));
    }
    renderPersonMandates(personMandates) {
        return React.createElement("tbody", null, this.renderPersonMandateRows(personMandates));
    }
    renderNoPersonMandatesNotice() {
        const { translate } = this.translateStore;
        return (React.createElement("tbody", null,
            React.createElement("tr", { style: { border: 'none' } },
                React.createElement("td", { colSpan: 6 },
                    React.createElement(Notice, { size: "small" }, translate('personPowers.personMandates.NONE'))))));
    }
    renderErrorNotice() {
        return (React.createElement(Notice, { type: "error", align: "center" }, this.translateStore.translate('personPowers.personMandates.queryFailed')));
    }
    renderPersonMandateRows(personMandates) {
        return personMandates.map((personMandate, index) => this.renderPersonMandateRowForRendering(personMandate, index));
    }
    renderPersonMandateRowForRendering(personMandate, index) {
        const { removePersonMandate } = this.mandateStore;
        const { translate } = this.translateStore;
        return (React.createElement("tr", { key: index },
            React.createElement("td", { className: "table__cell--3" },
                React.createElement("span", { className: "text-bold" }, personMandate.displayName)),
            React.createElement("td", { className: "table__cell--1" }, personMandate.registrationNumber),
            React.createElement("td", null, this.getPhoneValue(personMandate)),
            React.createElement("td", null, this.getEmailValue(personMandate)),
            React.createElement("td", { className: "table__cell--2" },
                React.createElement(RepresentationRightsMandateType, { mandate: personMandate, type: MandateQueryType.PERSON_MANDATES })),
            React.createElement("td", { className: "table__cell--1" },
                React.createElement(RepresentationRightsValidUntil, { mandates: personMandate.getVisibleMandates() })),
            React.createElement("td", { className: "table__cell--2" }, this.shouldShowRemoveMandateButton(personMandate) && (React.createElement(Button, { text: translate('personPowers.mandate.remove'), iconLeft: "#minus-round", type: "withdrawal", link: true, disabled: this.mandateStore.isRemovePersonMandateDisabled(personMandate), onClick: () => removePersonMandate(personMandate) })))));
    }
    shouldShowRemoveMandateButton(personMandate) {
        return (this.mandateStore.hasMandate([MandateType.LEGAL], true) &&
            !personMandate.mandates.some((mandate) => mandate.type === MandateType.LEGAL && mandate.source === 'STANDARD'));
    }
    getPhoneValue(personMandate) {
        return getValueOrDash(getPrimeOrFirstContactInfoValue(personMandate.contactInfos.PHONE));
    }
    getEmailValue(personMandate) {
        const email = getPrimeOrFirstContactInfoValue(personMandate.contactInfos.EMAIL);
        return (email && React.createElement(Button, { text: email, isUnderlined: false, link: true, url: `mailto:${email}` })) || React.createElement("span", null, "-");
    }
};
RepresentationRightsPersonMandates = __decorate([
    customerIdAsKey,
    injectStores,
    observer
], RepresentationRightsPersonMandates);
export default RepresentationRightsPersonMandates;
